import styled from 'styled-components'
import PropTypes from 'prop-types'

import { base } from '../../mixins'
import { PB70T } from '../../colors'
import { focusedStyles } from '../styles'

const Area = styled.textarea`
  ${base};
  padding: 10px 16px;
  border: 1px solid ${PB70T};
  border-radius: 5px;
  font-size: 16px;
  width: 100%;
  outline: 0;
  resize: none;

  &:focus {
    ${focusedStyles};
  }
`
/**
 *
 * The TextArea component can be used to collect multiple lines of text.
 */
const TextArea = ({ value, onChange, onBlur, rows = 3, placeholder = '' }) => {
  return (
    <Area
      cols={55}
      rows={rows}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
    />
  )
}

TextArea.propTypes = {
  /** The value of the textarea when controlled */
  value: PropTypes.string,
  /** The callback when the user types in the textarea */
  onChange: PropTypes.func,
  /** The callback when the textarea loses focus */
  onBlur: PropTypes.func,
  /** The number of rows for the textarea */
  rows: PropTypes.number,
  /** The placeholder for the textarea */
  placeholder: PropTypes.string
}

export { TextArea }
